<template>
  <div class="p-4">
    <div class="vx-row">
      <div class="vx-col w-full mb-base lg:w-1/3 xl:w-1/3 items-center" style="position: relative;">
        <vs-avatar
          v-if="newProfilePictureUrl"
          class="my-4 profile-picture"
          size="160px"
          :src="
            constants.s3Bucket +
            '/editor/profile-pictures/' +
            newProfilePictureUrl
          "
        />
        <vs-avatar
          v-else-if="localData.profilePictureUrl"
          class="my-4 profile-picture"
          size="160px"
          :src="
            constants.s3Bucket +
            '/editor/profile-pictures/' +
            localData.profilePictureUrl
          "
        />
        <vs-avatar
          v-else
          class="my-4 profile-picture"
          size="160px"
          :src="require('@/assets/images/icons/gender/default.png')"
        />
        <vs-button
          radius
          color="no-color"
          type="relief"
          icon="photo_camera"
          class="upload-btn vs-con-loading__container"
          @click="$refs.update_avatar_input.click()"
          ref="loadableButton"
          id="upload-profile-picture"
        ></vs-button>
        <vs-prompt
          title="Adjust Profile Picture"
          accept-text="Save"
          @cancel="closeEditProfilePicturePrompt"
          @accept="cropAndUploadProfilePicture"
          @close="closeEditProfilePicturePrompt"
          :active.sync="editProfilePicturePrompt"
        >
          <div class="con-exemple-prompt">
            <clipper-basic :src="tempProfilePicture" ref="clipper"></clipper-basic>
          </div>
        </vs-prompt>
        <input
          type="file"
          class="hidden"
          name="Profile Picture"
          ref="update_avatar_input"
          @change="openEditProfilePicturePrompt"
          accept="image/*"
        />
      </div>
      <div class="vx-col w-full lg:w-2/3 xl:w-2/3">
        <vs-row class="mb-base">
          <label>{{ $t('orgDashboard.userDashboard.settings.email') }}</label>
          <vs-input class="w-full" disabled v-model="userData.email" />
          <!-- <p>{{userData.email}}</p> -->
        </vs-row>
        <div class="mb-base">
          <div class="vx-row">
            <div class="vx-col w-full mb-base lg:w-1/2 xl:w-1/2">
              <label>{{ $t('orgDashboard.userDashboard.settings.firstName') }}</label>
              <vs-input class="w-full" v-model="localData.firstName" />
            </div>
            <div class="vx-col w-full mb-base lg:w-1/2 xl:w-1/2">
              <label>{{ $t('orgDashboard.userDashboard.settings.lastName') }}</label>
              <vs-input class="w-full" v-model="localData.lastName" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-full lg:w-1/2 xl:w-1/2 mb-base">
        <label>{{ $t('orgDashboard.userDashboard.settings.dateOfBirth') }}</label>
          <vs-input class="w-full" type="date" v-model="localData.dob" />
      </div>
      <div class="vx-col w-full lg:w-1/2 xl:w-1/2 mb-base">
        <label>{{ $t('orgDashboard.userDashboard.settings.gender') }}</label>
          <div class="my-3">
            <vs-radio
              class="mr-5"
              name="Gender"
              v-model="localData.gender"
              vs-value="female"
              ><vx-tooltip text="Female" position="bottom"
                ><img
                  src="@/assets/images/icons/gender/female.svg"
                  width="20px"
                  height="20px" /></vx-tooltip
            ></vs-radio>
            <vs-radio
              class="mr-5"
              name="Gender"
              v-model="localData.gender"
              vs-value="male"
              ><vx-tooltip text="Male" position="bottom"
                ><img
                  src="@/assets/images/icons/gender/male.svg"
                  width="20px"
                  height="20px" /></vx-tooltip
            ></vs-radio>
            <vs-radio
              name="Gender"
              v-model="localData.gender"
              vs-value="other"
              ><vx-tooltip text="Other" position="bottom"
                ><img
                  src="@/assets/images/icons/gender/circle-ring.svg"
                  width="20px"
                  height="20px" /></vx-tooltip
            ></vs-radio>
          </div>
      </div>
    </div>

    <div class="vx-row mb-base">
      <div class="vx-col w-full">
        <vs-row>
          <label>{{ $t('orgDashboard.userDashboard.settings.about') }}</label>
          <vs-textarea
            class="w-full"
            counter="200"
            :counter-danger.sync="counterDanger"
            maxlength="200"
            v-model="localData.about"
          />
        </vs-row>
      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button color="#44CC88" class="ml-auto mt-2" @click.stop="saveProfile()">{{ $t('orgDashboard.userDashboard.settings.saveChanges') }}</vs-button>
    </div>
  </div>
</template>

<script>
import { successNotifyService, failureNotifyService } from "@/services/errors.service.js";
import {
  saveInputFieldService,
  updateImageService,
} from "@/services/editor/about.service.js";
import constants from "@/constants";
export default {
  data() {
    return {
      counterDanger: false,
      localData: {},
      constants,
      editProfilePicturePrompt: false,
      tempProfilePicture: null,
      initialImgInput: null,
      newProfilePictureUrl: null
    };
  },
  computed: {
    isUserLoggedIn() {
      return this.$store.state.auth.isUserLoggedIn;
    },
    userData() {
      return this.$store.state.users.data;
    },
    userId() {
      return this.$store.state.auth.user._id;
    },
  },
  watch: {
    userData(newVal) {
      if (newVal) {
        this.localData = JSON.parse(JSON.stringify(this.userData));
        if (this.localData.dob) {
          this.localData.dob = this.localData.dob.split("T")[0];
        }
      }
    },
  },
  methods: {
    /*updateProfilePicture(input) {
      const payload = {
        imgInput: input,
        currentThis: this,
        _id: this.userId,
        maxSize: 1, // In MB
      };

      updateImageService(payload);
    },*/

    closeEditProfilePicturePrompt() {
      this.$forceUpdate();
    },
    profilePictureValidations(imgInput, maxSize) {
      if (imgInput.target.files && imgInput.target.files[0]) {
        let currentThis = this;

        if (imgInput.target.files > 1) {
          return;
        }
        const parts = imgInput.target.files[0].name.split(".");
        const ext = parts[parts.length - 1];

        //////////////////////////////////////////
        // Check for correct image file type
        //////////////////////////////////////////

        if (ext !== "jpg" && ext !== "jpeg" && ext !== "png") {
          const payload = {
            title: "Incorrect File Type",
            text:
              "Please upload a supported image file type, e.g. jpg, png, etc.",
            currentThis,
          };

          failureNotifyService(payload);

          return;
        }

        //////////////////////////////////////////
        // Check for image file size
        //////////////////////////////////////////

        if (imgInput.target.files[0].size / (1024 * 1024) > maxSize) {
          const payload = {
            title: "Image File Size Exceeded",
            text: "The size of the profile picture should be less than 1MB.",
            currentThis,
          };

          failureNotifyService(payload);

          return;
        }

        return true;
      }
    },
    openEditProfilePicturePrompt(input) {
      // Profile Picture Validation
      if (!this.profilePictureValidations(input, 1)) return; // 1 MB

      this.initialImgInput = input;

      const reader = new FileReader();
      reader.onload = (e) => {
        this.tempProfilePicture = e.target.result;
        this.editProfilePicturePrompt = true;
      };
      reader.readAsDataURL(input.target.files[0]);
    },
    cropAndUploadProfilePicture() {
      const currentThis = this;
      const canvas = this.$refs.clipper.clip();
      canvas.toBlob(function (blob) {
        const reader = new FileReader();
        reader.onload = (e) => {
          // // console.log(e.target.result);
          currentThis.updateImageService(e.target.result)
        };
        reader.readAsDataURL(blob);
      });
    },
    updateImageService(finalImgData) {
      const _id = this.userId;

      this.$store.commit("editor/TOGGLE_SAVE_IN_PROGRESS", true);

      this.$vs.loading({
        container: "#upload-profile-picture",
        color: "primary",
        background: "white",
        scale: 0.45,
      });

      const profilePictureData = finalImgData;
      const profilePictureUrl = _id + "-" + this.initialImgInput.target.files[0].name;

      const ppObj = {
        profilePictureData,
        profilePictureUrl,
      };

      this.$store
        .dispatch("users/updateProfilePicture", {
          ppObj,
          _id,
        })
        .then((res) => {
          this.$store.commit("editor/TOGGLE_SAVE_IN_PROGRESS", false);
          this.newProfilePictureUrl = res.data.profilePictureUrl;
          this.$forceUpdate();
          this.$vs.loading.close("#upload-profile-picture > .con-vs-loading");
        })
        .catch((err) => {
          throw err;
        });
    },
    saveProfile() {

      const payload = {
        _id: this.userId,
        firstName: this.localData.firstName,
        lastName: this.localData.lastName,
        dob: this.localData.dob,
        gender: this.localData.gender,
        about: this.localData.about,
      };

      // // console.log(payload);

      this.$store.dispatch('users/saveProfile', payload).then(() => {
        successNotifyService({currentThis: this, title: 'Profile Updated Successfully', text: 'Your profile has been updated successfully'})
      }).catch(err => {
        throw err;
      })
    },
  },
  created() {
    if (this.isUserLoggedIn) {
      if (Object.keys(this.userData).length) {
        this.localData = JSON.parse(JSON.stringify(this.userData));
        if (this.localData.dob) {
          this.localData.dob = this.localData.dob.split("T")[0];
        }
      }
    }
  }
};
</script>

<style scoped>
.organization-culture {
  border: 1px solid #ebedf0;
  box-sizing: border-box;
  border-radius: 8px;
  cursor: pointer;

  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: #414040;
}

.organization-culture:hover {
  background: #5585ff;
  color: white;
}

.organization-culture .selected {
  background: #5585ff;
  border-radius: 8px;
}

.vs-con-textarea {
  background: #fbfbfc;
  border: 1px solid #ebedf0 !important;
  box-sizing: border-box;
  border-radius: 6px;
  /*height: 109px;*/

  font-weight: normal;
  font-size: 1rem; /*16px*/
  line-height: 19px;
  letter-spacing: -0.02em;

  color: #888888;

  margin-bottom: 0;
}

.vs-con-textarea >>> .vs-textarea {
  background: #fbfbfc;
  /*border: 1px solid #EBEDF0!important;*/
  box-sizing: border-box;
  border-radius: 6px;
  height: 100px !important;

  font-weight: normal;
  font-size: 1rem; /*16px;*/
  line-height: 19px;
  letter-spacing: -0.02em;

  color: #888888;
}

.vs-button {
  border-radius: 6px;
}

.profile-picture {
  position: relative;
  width: 8rem;
  height: 8rem;
}

.upload-btn {
  position: absolute;
  margin: auto;
  background: rgba(255, 255, 255, 0.35) !important;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>
